var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpenedHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86476 5.40798H2.4746C1.6107 5.40798 0.899994 6.11537 0.899994 6.9927V11.7759C0.913978 12.6675 1.6107 13.375 2.4746 13.375H9.52539C10.4033 13.3608 11.1 12.6533 11.1 11.7759V6.99295C11.086 6.10142 10.3893 5.39388 9.52539 5.39388H9.31839V5.39868H8.35495H8.3549H7.78839V5.39379L3.64516 5.39388V3.87969C3.64516 2.49286 4.60663 1.41742 6.01398 1.41742C7.43521 1.41742 8.3549 2.52116 8.3549 3.87969V3.94518H9.13522V3.87969C9.13522 2.08254 7.8672 0.625 6.01393 0.625C4.16061 0.625 2.86476 2.05428 2.86476 3.87969V5.40798ZM2.47458 12.5683C2.04264 12.5683 1.69428 12.2145 1.69428 11.7759V6.99287C1.69428 6.55422 2.04264 6.20045 2.47458 6.20045H9.52536C9.9573 6.20045 10.3057 6.55422 10.3057 6.99287V11.7759C10.3057 12.2145 9.9573 12.5683 9.52536 12.5683H2.47458ZM5.60983 9.28533C5.37295 9.1438 5.21967 8.88914 5.21967 8.59192C5.21967 8.13907 5.56808 7.78528 6.00002 7.7995C6.43196 7.7995 6.78032 8.15327 6.78032 8.59192C6.78032 8.88911 6.62703 9.14378 6.39016 9.28533V10.5872C6.39016 10.7994 6.22297 10.9834 5.99999 10.9834C5.79101 10.9834 5.60983 10.8136 5.60983 10.5872V9.28533Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenedHint);
export default __webpack_public_path__ + "static/media/lock-opened-hint.3e66afecc24f3e099a7d0cfededfc616.svg";
export { ForwardRef as ReactComponent };